import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "check"];
import { jsx as _jsx } from "react/jsx-runtime";
import { CheckOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';
var Tag = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var color = _ref.color,
      check = _ref.check,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    style: {
      backgroundColor: color
    },
    ref: ref,
    children: check ? _jsx(CheckOutlined, {}) : ''
  }));
});

var ThemeColor = function ThemeColor(_ref2) {
  var value = _ref2.value,
      colorList = _ref2.colorList,
      onChange = _ref2.onChange,
      prefixCls = _ref2.prefixCls,
      formatMessage = _ref2.formatMessage,
      hashId = _ref2.hashId;

  if (!colorList || (colorList === null || colorList === void 0 ? void 0 : colorList.length) < 1) {
    return null;
  }

  var baseClassName = "".concat(prefixCls, "-theme-color");
  return _jsx("div", {
    className: "".concat(baseClassName, " ").concat(hashId),
    children: colorList === null || colorList === void 0 ? void 0 : colorList.map(function (_ref3) {
      var key = _ref3.key,
          color = _ref3.color;
      if (!key) return null;
      return _jsx(Tooltip, {
        title: formatMessage({
          id: "app.setting.themecolor.".concat(key)
        }),
        children: _jsx(Tag, {
          className: "".concat(baseClassName, "-block ").concat(hashId),
          color: color,
          check: value === color,
          onClick: function onClick() {
            return onChange && onChange(color);
          }
        })
      }, color);
    })
  });
};

export { ThemeColor };